import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useHistory, useLocation } from 'react-router-dom';
import { decode } from 'jsonwebtoken';
import useGlobalModalContext from '../../hooks/useGlobalModalContext';
import ProgressBackdrop from '../../preorder/components/ProgressBackdrop';
import { authActionType, useAuthDispatch } from '../../preorder/plugins/Auth';
import { getUserProfile, lineAuth } from '../../register/api/auth';

const Page = styled.div`
  min-height: 100vh;
`;

const LineLoginCallback = () => {
  const location = useLocation();
  const history = useHistory();
  const authDispatch = useAuthDispatch();
  const { openModal } = useGlobalModalContext();

  useEffect(() => {
    const doSomething = async () => {
      try {
        const { state } = location || {};
        const { code, afterLoginUrl } = state || {};

        if (!code) throw new Error('missing parameter code');
        else {
          const authReqult = await lineAuth(state);
          const { data: { token }, status } = authReqult || {};

          if (status !== 'success') throw new Error('auth with line fail');

          const tokenData = decode(token);
          const { customerId } = tokenData;

          if (customerId) {
            const profileResult = await getUserProfile(token);
            const { data: profile, status: getUserProfileStatus } = profileResult || {};

            if (getUserProfileStatus !== 'success') throw new Error('get user profile fail');

            authDispatch({
              type: authActionType.LOGIN_SUCCESS,
              payload: {
                token,
                user: {
                  ...profile,
                },
              },
            });

            history.push(afterLoginUrl, {
              ...state,
            });
          } else {
            history.push({
              pathname: '/register/connect-phone',
              state: {
                token,
                isConnectPhone: true,
                ...state,
              },
            });
          }
        }
      } catch (e) {
        console.log(e.message);
        openModal({
          title: '登入失敗',
          content: '登入失敗，請連繫專人客服。',
        });
        history.push('/');
      }
    };

    doSomething();
  }, [location, authDispatch, history, openModal]);

  return <Page><ProgressBackdrop isShow /></Page>;
};

export default LineLoginCallback;
